import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sugarCrm = defineConnector({
  identifier: "sugarCrm",
  name: "SugarCRM",
  tagLine: "Customer relationship management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your SugarCRM credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [SugarCRM](https://www.sugarcrm.com/) instance. Navigate to **Admin → OAuth Keys** and create a new OAuth2 key pair, or use an existing API platform user’s credentials to obtain an access token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          placeholder: "https://yourinstance.sugarondemand.com",
          target: { kind: "configuration", field: "host" },
          helperText:
            "Your SugarCRM instance URL (e.g., https://yourinstance.sugarondemand.com)",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => ({
      url: `${host}/rest/v11/me`,
    }),
  },
});
